import React from 'react';
import { Navigate } from 'react-router-dom';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import { canAccessEngineeringModule } from '../../utils/roleConstants';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import config from '../../../config';
import utils from '../../utils';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import { ObsoleteStatusBadge } from '../../_components/ObsoletePartNoCell';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

const PART_TYPES = [
    { value: 'RM', label: 'RM' },
    { value: 'SEMI_FG', label: 'Semi-FG' },
    { value: 'FG', label: 'FG' }
];

const TABLE_FILTERS = [
    { value: 'ALL', label: 'All' },
    { value: 'RM', label: 'RM' },
    { value: 'SEMI_FG', label: 'SEMI-FG' },
    { value: 'FG', label: 'FG' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'OBSOLETE', label: 'Obsolete' }
];

class NewPartCreation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            partType: 'RM',
            partNoPrefix: '',
            partNo: '',
            customerPartNo: '',
            supplierPartNo: '',
            supplier1: '',
            supplier2: '',
            supplier3: '',
            customer: '',
            description: '',
            company: 0,
            products: [],
            keyword: '',
            tableFilter: 'ALL',
            modalShow: false,
            newMode: false,
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            offset: 0,
            companyName: '',
            loading: false
        };
        this.tableRequestSeq = 0;

        this.columns = [
            {
                name: 'No',
                selector: row => row.no,
                width: '80px',
            },
            {
                name: 'Full Part No',
                selector: row => row.fullPartNo,
                cell: row => <DataTableEllipsisText value={row.fullPartNo} />,
                sortable: true,
                minWidth: '200px',
            },
            {
                name: 'Type',
                selector: row => row.partTypeLabel,
                cell: row => <DataTableEllipsisText value={row.partTypeLabel} />,
                sortable: true,
                width: '120px',
            },
            {
                name: 'Description',
                selector: row => row.description,
                cell: row => <DataTableEllipsisText value={row.description} />,
                sortable: true,
                grow: 2,
                minWidth: '240px',
            },
            {
                name: 'Customer Part No',
                selector: row => row.customerPartNo,
                cell: row => <DataTableEllipsisText value={row.customerPartNo} />,
                sortable: true,
                minWidth: '180px',
            },
            {
                name: 'Supplier Part No',
                selector: row => row.supplierPartNo,
                cell: row => <DataTableEllipsisText value={row.supplierPartNo} />,
                sortable: true,
                minWidth: '180px',
            },
            {
                name: 'Status',
                selector: row => row.isObsolete ? 'Obsolete' : 'Active',
                cell: row => row.isObsolete ? <ObsoleteStatusBadge /> : <span>Active</span>,
                sortable: true,
                width: '120px',
            },
            {
                name: '',
                cell: row => this.cellButton(row),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '230px',
                minWidth: '230px',
            }
        ];
    }

    componentDidMount() {
        this.fetchCompanyName();
        this.buildHtmlTable();
    }

    safeString(value) {
        if (value === null || value === undefined) return '';
        const text = String(value);
        return text === 'null' || text === 'undefined' ? '' : text;
    }

    safeNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        const numberValue = Number(value);
        return isNaN(numberValue) ? 0 : numberValue;
    }

    safeBoolean(value) {
        return value === true || value === 1 || value === '1';
    }

    getUser() {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch (error) {
            return null;
        }
    }

    getRevisionEditorPayload() {
        const currentUser = this.getUser() || {};
        const updatedByName = currentUser.firstName || currentUser.lastName
            ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim()
            : currentUser.username;

        return {
            updatedBy: currentUser.id || currentUser.accountId || currentUser.username,
            updatedByName,
        };
    }

    getPartTypeLabel(value) {
        const match = PART_TYPES.find(type => type.value === value);
        return match ? match.label : value;
    }

    shouldShowCustomerPartNo(partType = this.state.partType) {
        return partType === 'FG' || partType === 'SEMI_FG';
    }

    shouldShowSupplierPartNo(partType = this.state.partType) {
        return partType === 'RM';
    }

    shouldShowSupplierFields(partType = this.state.partType) {
        return partType === 'RM';
    }

    shouldShowCustomerFields(partType = this.state.partType) {
        return partType === 'FG' || partType === 'SEMI_FG';
    }

    normalizePart(data, index, offset) {
        const partType = this.safeString(data.partType || 'RM');
        return {
            no: index + offset + 1,
            id: data.id,
            partType,
            partTypeLabel: this.getPartTypeLabel(partType),
            partNoPrefix: this.safeString(data.partNoPrefix),
            partNo: this.safeString(data.partNo),
            fullPartNo: this.safeString(data.fullPartNo),
            customerPartNo: this.safeString(data.customerPartNo),
            supplierPartNo: this.safeString(data.supplierPartNo),
            supplier1: this.safeString(data.supplier1),
            supplier2: this.safeString(data.supplier2),
            supplier3: this.safeString(data.supplier3),
            customer: this.safeString(data.customer),
            description: this.safeString(data.description),
            isObsolete: this.safeBoolean(data.isObsolete),
            company: this.safeNumber(data.company)
        };
    }

    fetchCompanyName() {
        const user = this.getUser();
        if (!user || !user.accountId) return Promise.resolve('');

        return fetch(`${config.apiUrl}/getAccounts`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.text().then(text => text && JSON.parse(text)))
            .then(accounts => {
                const list = Array.isArray(accounts) ? accounts : [];
                const account = list.find(item => Number(item.id) === Number(user.accountId));
                if (account && account.companyName) {
                    this.setState({ companyName: account.companyName });
                    return account.companyName;
                }
                return '';
            })
            .catch(() => {
                this.setState({ companyName: '' });
                return '';
            });
    }

    getCompanyPrefix() {
        const user = this.getUser();
        const name = this.state.companyName || user?.companyName || user?.accountName || 'COMPANY';
        const prefix = String(name).trim().toUpperCase().replace(/[^A-Z0-9]+/g, '');
        return prefix || 'COMPANY';
    }

    getDefaultPartNoPrefix() {
        const user = this.getUser();
        const name = this.state.companyName || user?.companyName || user?.accountName || 'COMPANY';
        return this.formatPartNoPrefix(name || 'COMPANY');
    }

    formatPartNoPrefix(value) {
        return this.safeString(value).trim().toUpperCase();
    }

    getPartNoPreview(partNoPrefix = this.state.partNoPrefix, partNo = this.state.partNo) {
        return `${this.formatPartNoPrefix(partNoPrefix)}${this.safeString(partNo).trim()}`;
    }

    fetchNextPartNo() {
        const user = this.getUser();
        if (!user || !user.accountId) return Promise.resolve('0000001');

        return fetch(`${config.apiUrl}/getNextNewPartCreationPartNo?company=${user.accountId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.text().then(text => text && JSON.parse(text)))
            .then(body => this.safeString(body && body.partNo).trim() || '0000001')
            .catch(() => '0000001');
    }

    parseJsonResponse(response) {
        return response.text()
            .then(text => {
                let body = {};
                if (text) {
                    try {
                        body = JSON.parse(text);
                    } catch (error) {
                        body = {};
                    }
                }
                return { response, body };
            });
    }

    buildHtmlTable(page = null, limit = null) {
        const user = this.getUser();
        if (!user || !user.accountId) return Promise.resolve();

        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const keyword = encodeURIComponent(this.state.keyword || '');
        const tableFilter = encodeURIComponent(this.state.tableFilter || 'ALL');
        const requestSeq = ++this.tableRequestSeq;
        this.setState({ loading: true });

        return fetch(`${config.apiUrl}/getNewPartCreationByCompany?company=${user.accountId}&keyword=${keyword}&filter=${tableFilter}&limit=${rowsPerPage}&offset=${offset}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.text().then(text => text && JSON.parse(text)))
            .then(body => {
                if (requestSeq !== this.tableRequestSeq) return;

                const data = body && body.data && Array.isArray(body.data) ? body.data : [];
                const totalRows = body && body.meta && body.meta.total_count ? body.meta.total_count : data.length;

                this.setState({
                    products: data.map((item, index) => this.normalizePart(item, index, offset)),
                    totalRows,
                    currentPage,
                    rowsPerPage,
                    offset,
                    loading: false
                });
            })
            .catch(error => {
                if (requestSeq !== this.tableRequestSeq) return;

                console.error('Error fetching new part data:', error);
                this.setState({ products: [], totalRows: 0, loading: false });
            });
    }

    exportExcel() {
        utils.tableToExcel('new-part-creation-export-table', 'newpartcreation', 'NewPartCreation_' + moment().format('YYYYMMDD') + '.xls');
    }

    async openNewModal() {
        if (!this.state.companyName) {
            await this.fetchCompanyName();
        }
        const nextPartNo = await this.fetchNextPartNo();

        this.setState({
            id: 0,
            partType: 'RM',
            partNoPrefix: this.getDefaultPartNoPrefix(),
            partNo: nextPartNo,
            customerPartNo: '',
            supplierPartNo: '',
            supplier1: '',
            supplier2: '',
            supplier3: '',
            customer: '',
            description: '',
            newMode: true,
            modalShow: true
        });
    }

    onClickProductSelected(row) {
        this.setState({
            newMode: false,
            id: this.safeNumber(row.id),
            partType: this.safeString(row.partType || 'RM'),
            partNoPrefix: this.safeString(row.partNoPrefix),
            partNo: this.safeString(row.partNo),
            customerPartNo: this.safeString(row.customerPartNo),
            supplierPartNo: this.safeString(row.supplierPartNo),
            supplier1: this.safeString(row.supplier1),
            supplier2: this.safeString(row.supplier2),
            supplier3: this.safeString(row.supplier3),
            customer: this.safeString(row.customer),
            description: this.safeString(row.description),
            company: this.safeNumber(row.company),
            modalShow: true
        });
    }

    onUpdateObsoleteStatus(row, obsoleteStatus) {
        fetch(`${config.apiUrl}/updateNewPartCreationObsoleteStatus`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: row.id,
                isObsolete: obsoleteStatus,
                ...this.getRevisionEditorPayload(),
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert(obsoleteStatus ? 'Marked as obsolete successfully.' : 'Marked as active successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    cellButton(row) {
        const nextObsoleteStatus = !row.isObsolete;
        const statusLabel = row.isObsolete ? 'Mark as active' : 'Mark as obsolete';
        const confirmMessage = row.isObsolete
            ? 'Are you sure you want to mark this New Part as active?'
            : 'Are you sure you want to mark this New Part as obsolete?';

        return (
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '230px', paddingRight: '10px' }}>
                <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() => this.onClickProductSelected(row)}
                >
                    Edit
                </button>
                <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() => window.confirm(confirmMessage) && this.onUpdateObsoleteStatus(row, nextObsoleteStatus)}
                >
                    {statusLabel}
                </button>
            </div>
        );
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };

    render() {
        const user = this.getUser();
        if (!user) {
            return <Navigate to="/login" replace />;
        }
        if (!canAccessEngineeringModule(user)) {
            return <Navigate to="/" replace />;
        }

        let { keyword, tableFilter, modalShow, newMode, products } = this.state;
        const partType = this.safeString(this.state.partType || 'RM');
        const partNoPrefix = this.safeString(this.state.partNoPrefix);
        const partNo = this.safeString(this.state.partNo);
        const customerPartNo = this.safeString(this.state.customerPartNo);
        const supplierPartNo = this.safeString(this.state.supplierPartNo);
        const supplier1 = this.safeString(this.state.supplier1);
        const supplier2 = this.safeString(this.state.supplier2);
        const supplier3 = this.safeString(this.state.supplier3);
        const customer = this.safeString(this.state.customer);
        const description = this.safeString(this.state.description);
        const fullPartNo = this.getPartNoPreview(partNoPrefix, partNo);

        let handleClose = () => {
            this.setState({
                modalShow: false,
                id: 0,
                partType: 'RM',
                partNoPrefix: '',
                partNo: '',
                customerPartNo: '',
                supplierPartNo: '',
                supplier1: '',
                supplier2: '',
                supplier3: '',
                customer: '',
                description: ''
            });
        };

        const payload = {
            partType,
            partNoPrefix: this.formatPartNoPrefix(partNoPrefix),
            partNo: partNo.trim(),
            fullPartNo,
            customerPartNo: this.shouldShowCustomerPartNo(partType) ? customerPartNo : '',
            supplierPartNo: this.shouldShowSupplierPartNo(partType) ? supplierPartNo : '',
            supplier1: this.shouldShowSupplierFields(partType) ? supplier1 : '',
            supplier2: this.shouldShowSupplierFields(partType) ? supplier2 : '',
            supplier3: this.shouldShowSupplierFields(partType) ? supplier3 : '',
            customer: this.shouldShowCustomerFields(partType) ? customer : '',
            description
        };

        let handleSave = () => {
            if (!payload.partNo) {
                window.alert('Part No is required.');
                return;
            }

            window.confirm('Are you sure you update this data?') && fetch(`${config.apiUrl}/updateNewPartCreation`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...payload,
                    id: this.state.id,
                    ...this.getRevisionEditorPayload(),
                })
            })
                .then(response => this.parseJsonResponse(response))
                .then(({ response, body }) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    } else {
                        window.alert(body.error || 'Failed to update data.');
                    }
                });
        };

        let handleCreate = () => {
            if (!payload.partNo) {
                window.alert('Part No is required.');
                return;
            }

            fetch(`${config.apiUrl}/uploadNewPartCreation`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...payload,
                    company: user && user.accountId,
                    ...this.getRevisionEditorPayload(),
                })
            })
                .then(response => this.parseJsonResponse(response))
                .then(({ response, body }) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false, newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    } else {
                        window.alert(body.error || 'Failed to create data.');
                    }
                });
        };

        return (
            <div className="container">
                <div style={{
                    marginBottom: '20px',
                    position: 'relative',
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl
                                type="text"
                                placeholder="Search..."
                                onChange={ev => { this.setState({ keyword: ev.target.value }); }}
                                value={keyword || ''}
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <FormGroup controlId="formInlineTableFilter">
                            <FormControl
                                as="select"
                                value={tableFilter || 'ALL'}
                                onChange={ev => {
                                    this.setState({
                                        tableFilter: ev.target.value,
                                        currentPage: 1,
                                        offset: 0
                                    }, () => {
                                        this.buildHtmlTable(1, this.state.rowsPerPage);
                                    });
                                }}
                                style={{ minWidth: '150px' }}
                            >
                                {TABLE_FILTERS.map(filter => (
                                    <option key={filter.value} value={filter.value}>{filter.label}</option>
                                ))}
                            </FormControl>
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={() => {
                                this.setState({ currentPage: 1, offset: 0 }, () => {
                                    this.buildHtmlTable(1, this.state.rowsPerPage);
                                });
                            }}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={() => this.exportExcel()}>Export</Button>
                        <Button
                            bsStyle="danger"
                            onClick={() => this.openNewModal()}>New</Button>
                    </div>
                    <a id="dlink" style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" className="container" style={{ overflow: 'visible' }} >
                    <DataTable
                        columns={this.columns}
                        data={products || []}
                        progressPending={this.state.loading}
                        progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading new part records" />}
                        pagination
                        paginationServer
                        paginationTotalRows={this.state.totalRows}
                        paginationPerPage={this.state.rowsPerPage}
                        paginationDefaultPage={this.state.currentPage}
                        onChangePage={this.handlePageChange}
                        onChangeRowsPerPage={this.handleRowsPerPageChange}
                        highlightOnHover
                    />
                </div>
                <div id="new-part-creation-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Full Part No</th>
                                <th style={{ padding: '6px' }}>Type</th>
                                <th style={{ padding: '6px' }}>Description</th>
                                <th style={{ padding: '6px' }}>Customer Part No</th>
                                <th style={{ padding: '6px' }}>Supplier Part No</th>
                                <th style={{ padding: '6px' }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(products || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{item.no || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partTypeLabel || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.fullPartNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.customerPartNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.supplierPartNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.description || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.isObsolete ? 'Obsolete' : 'Active'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            {newMode ? (<Modal.Title>New Part Creation</Modal.Title>) : (<Modal.Title>Edit Part</Modal.Title>)}
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <Form>
                                    <FormGroup className="row" as={Row} controlId="formInlinePartType" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Part Type</Form.Label></Col>
                                        <Col sm={3}>
                                            <FormControl as="select"
                                                value={partType}
                                                onChange={ev => {
                                                    const nextPartType = ev.target.value;
                                                    this.setState({
                                                        partType: nextPartType,
                                                        customerPartNo: this.shouldShowCustomerPartNo(nextPartType) ? this.state.customerPartNo : '',
                                                        supplierPartNo: this.shouldShowSupplierPartNo(nextPartType) ? this.state.supplierPartNo : '',
                                                        supplier1: this.shouldShowSupplierFields(nextPartType) ? this.state.supplier1 : '',
                                                        supplier2: this.shouldShowSupplierFields(nextPartType) ? this.state.supplier2 : '',
                                                        supplier3: this.shouldShowSupplierFields(nextPartType) ? this.state.supplier3 : '',
                                                        customer: this.shouldShowCustomerFields(nextPartType) ? this.state.customer : ''
                                                    });
                                                }}>
                                                {PART_TYPES.map(type => (
                                                    <option key={type.value} value={type.value}>{type.label}</option>
                                                ))}
                                            </FormControl>
                                        </Col>
                                        <Col sm={3}><Form.Label>Part No Prefix</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ partNoPrefix: this.formatPartNoPrefix(ev.target.value) }); }} value={partNoPrefix} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlinePartRefs" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ partNo: ev.target.value }); }} value={partNo} /></Col>
                                        <Col sm={3}><Form.Label>Part No Preview</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" readOnly value={fullPartNo} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlinePartAltNo" style={{ marginBottom: '15px' }}>
                                        {this.shouldShowCustomerPartNo(partType) && (
                                            <React.Fragment>
                                                <Col sm={3}><Form.Label>Customer Part No</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ customerPartNo: ev.target.value }); }} value={customerPartNo} /></Col>
                                            </React.Fragment>
                                        )}
                                        {this.shouldShowCustomerFields(partType) && (
                                            <React.Fragment>
                                                <Col sm={3}><Form.Label>Customer</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ customer: ev.target.value }); }} value={customer} /></Col>
                                            </React.Fragment>
                                        )}
                                        {this.shouldShowSupplierPartNo(partType) && (
                                            <React.Fragment>
                                                <Col sm={3}><Form.Label>Supplier Part No</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ supplierPartNo: ev.target.value }); }} value={supplierPartNo} /></Col>
                                            </React.Fragment>
                                        )}
                                        {this.shouldShowSupplierFields(partType) && (
                                            <React.Fragment>
                                                <Col sm={3}><Form.Label>Supplier 1</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ supplier1: ev.target.value }); }} value={supplier1} /></Col>
                                            </React.Fragment>
                                        )}
                                    </FormGroup>
                                    {this.shouldShowSupplierFields(partType) && (
                                        <React.Fragment>
                                            <FormGroup className="row" as={Row} controlId="formInlineSuppliers" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Supplier 2</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ supplier2: ev.target.value }); }} value={supplier2} /></Col>
                                                <Col sm={3}><Form.Label>Supplier 3</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ supplier3: ev.target.value }); }} value={supplier3} /></Col>
                                            </FormGroup>
                                        </React.Fragment>
                                    )}

                                    <FormGroup className="row" as={Row} controlId="formInlineDescription" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Description</Form.Label></Col>
                                        <Col sm={9}>
                                            <FormControl
                                                as="textarea"
                                                rows={3}
                                                onChange={ev => { this.setState({ description: ev.target.value }); }}
                                                value={description}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {newMode && (<Button variant="primary" onClick={handleCreate}>
                                Create
                            </Button>)}
                            {!newMode && (<Button variant="primary" onClick={handleSave}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}
export { NewPartCreation };
